<template>
  <SpIphone>
    <div
      v-for="(item, index) in attachment"
      :key="index"
      class="content"
    >
      <!-- 标题 -->
      <!-- <el-row v-if="item[item.msgtype].title">
        <el-col :span="5">
          <div class="left">
            <el-avatar
              class="avatar"
              shape="square"
              :size="24"
              icon="el-icon-user-solid"
            />
          </div>
        </el-col>
        <el-col :span="19">
          <div class="right">
            <div class="bubbles text-bubbles">
              <div class="text_msg">
                {{ item[item.msgtype].title }}
              </div>
            </div>
          </div>
        </el-col>
      </el-row> -->

      <!-- 图片 -->
      <el-row v-if="item.msgtype === 'image'">
        <el-col :span="5">
          <div class="left">
            <el-avatar
              class="avatar"
              shape="square"
              :size="24"
              icon="el-icon-user-solid"
            />
          </div>
        </el-col>
        <el-col :span="19">
          <div class="right">
            <div>
              <img
                class="upload-pic"
                :src="item[item.msgtype].image_url"
                alt=""
              >
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 视频 -->
      <el-row v-if="item.msgtype === 'video'">
        <el-col :span="5">
          <div class="left">
            <el-avatar
              class="avatar"
              shape="square"
              :size="24"
              icon="el-icon-user-solid"
            />
          </div>
        </el-col>
        <el-col :span="19">
          <div class="right">
            <div class="video-box">
              <video
                class="upload-pic"
                :src="item[item.msgtype].video_url"
              />
              <div class="el-icon-caret-right video-play-icon" />
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 小程序 -->
      <el-row
        v-if="
          item.msgtype === 'item' || item.msgtype === 'coupon' || item.msgtype === 'miniprogram'
        "
      >
        <el-col :span="5">
          <div class="left">
            <el-avatar
              class="avatar"
              shape="square"
              :size="24"
              icon="el-icon-user-solid"
            />
          </div>
        </el-col>
        <el-col :span="19">
          <div class="right">
            <div class="bubbles program">
              <span class="program-title">{{ item[item.msgtype].title }}</span>
              <img
                class="program-pic"
                :src="item[item.msgtype].miniprogram_picurl"
                alt=""
              >
              <div class="program-tips">
                <img
                  src="@/assets/img/wechat.png"
                  alt=""
                >
                小程序
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </SpIphone>
</template>

<script>
export default {
  name: 'IphoneContent',
  props: {
    attachment: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      key: 1
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
.content {
  ::v-deep {
    .el-row {
      margin-bottom: 6px;
    }
  }
  .left {
    .avatar {
      background-color: rgb(68, 143, 247);
    }
  }
  .right {
    .upload-pic {
      display: block;
      width: 110px;
      height: 80px;
      background-color: #333;
    }
    .video-box {
      width: 110px;
      height: 80px;
      position: relative;
    }
    .video-play-icon {
      width: 28px;
      height: 28px;
      color: #fff;
      font-size: 24px;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }

    .bubbles {
      .text_msg {
        word-wrap: break-all;
      }
      font-size: 12px;
      padding: 6px 8px;
      border-radius: 2px;
      display: inline-block;
      background-color: #fff;
      position: relative;
      padding: 2px 6px;
      line-height: 20px;

      &::after {
        content: ' ';
        position: absolute;
        left: -5px;
        top: 8px;

        width: 0;
        height: 0;
        border-top: 3px solid transparent;
        border-right: 6px solid #fff;
        border-bottom: 3px solid transparent;
      }
    }
    .text-bubbles {
      width: 100%;
      overflow-wrap: break-word;
    }
    .link {
      .link-title {
        color: #999;
        font-size: 12px;
      }
      .h5-link {
        display: flex;
        color: #999;
        margin-top: 4px;
        .link-name {
          width: 80px;
          word-wrap: break-word;
          line-height: 15px;
          font-size: 12px;
          margin-right: 2px;
        }
        .link-pic {
          width: 30px;
          height: 30px;
        }
      }
    }

    .program {
      .program-pic {
        display: block;
        width: 110px;
        height: 80px;
        background-color: #333;
      }
      .program-tips {
        margin-top: 5px;
        border-top: 1px solid #dcdfe6;
        font-size: 12px;
        img {
          display: inline;
          width: 10px;
          height: 10px;
        }
      }
    }
  }
}
</style>
